import { render, staticRenderFns } from "./accurate-distribute.vue?vue&type=template&id=73c96418&scoped=true"
import script from "./accurate-distribute.vue?vue&type=script&lang=js"
export * from "./accurate-distribute.vue?vue&type=script&lang=js"
import style0 from "./accurate-distribute.vue?vue&type=style&index=0&id=73c96418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c96418",
  null
  
)

export default component.exports